import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Alert } from "@mui/material";
import StudentsTable from "../components/studentslist/StudentsTable";

export default function SessionTable() {
    const { search } = useLocation();
    const studentId = new URLSearchParams(search).get("studentId");
    return (
        <Box>
            {studentId && <Alert severity="info">Показаны сессии выбранного студента</Alert>}
            <StudentsTable key={studentId || "all"} studentId={studentId} mode={3} />
        </Box>
    );
}
